import React from 'react';

const Loader = ({ fullScreen = false, size = 'md', text = '' }) => {
  const sizeClasses = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border',
  };

  if (fullScreen) {
    return (
      <div className="loader-fullscreen d-flex flex-column justify-content-center align-items-center">
        <div className={`spinner-border text-danger ${sizeClasses[size]}`} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        {text && <p className="mt-3 text-muted">{text}</p>}
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center p-4">
      <div className={`spinner-border text-danger ${sizeClasses[size]}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {text && <span className="ms-2 text-muted">{text}</span>}
    </div>
  );
};

export default Loader;
